/**
 * Campaign Terms Info Modal — shared by every campaign type.
 * Renders the selected campaign's terms & conditions in a full-screen modal.
 */

import React from 'react';

import BaseModal from 'shared/components/BaseModal';
import styles from './CampaignTermsInfoModal.module.css';

interface TermsInfoModalProps {
  title: string;
  content?: string;
  onClose: () => void;
}

const CampaignTermsInfoModal: React.FC<TermsInfoModalProps> = ({ title, content, onClose }) => {
  return (
    <BaseModal
      styles={styles as { modalContainer: string; closeModalIcon: string }}
      closeModalIcon="/ui/menuClose"
      onClose={onClose}
    >
      <div className={styles.modalContentWrapper}>
        <span className={styles.modalTitle}>{title}</span>
        <div className={styles.termsText} dangerouslySetInnerHTML={{ __html: content ?? '' }} />
      </div>
    </BaseModal>
  );
};

export default CampaignTermsInfoModal;
